module.exports = __webpack_public_path__ + "static/media/knives.bb940fd8.png";